function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-133.000000, -222.000000)",
  fill: "#3A4164"
}, /*#__PURE__*/React.createElement("path", {
  d: "M155.285714,222 L134.708929,222 C133.766071,222 133,222.776786 133,223.730357 L133,244.269643 C133,245.223214 133.766071,246 134.708929,246 L155.285714,246 C156.228571,246 157,245.223214 157,244.269643 L157,223.730357 C157,222.776786 156.228571,222 155.285714,222 Z M140.253571,242.571429 L136.696429,242.571429 L136.696429,231.117857 L140.258929,231.117857 L140.258929,242.571429 L140.253571,242.571429 Z M138.475,229.553571 C137.333929,229.553571 136.4125,228.626786 136.4125,227.491071 C136.4125,226.355357 137.333929,225.428571 138.475,225.428571 C139.610714,225.428571 140.5375,226.355357 140.5375,227.491071 C140.5375,228.632143 139.616071,229.553571 138.475,229.553571 L138.475,229.553571 Z M153.5875,242.571429 L150.030357,242.571429 L150.030357,237 C150.030357,235.671429 150.003571,233.9625 148.182143,233.9625 C146.328571,233.9625 146.044643,235.408929 146.044643,236.903571 L146.044643,242.571429 L142.4875,242.571429 L142.4875,231.117857 L145.9,231.117857 L145.9,232.682143 L145.948214,232.682143 C146.425,231.782143 147.5875,230.833929 149.317857,230.833929 C152.917857,230.833929 153.5875,233.207143 153.5875,236.292857 L153.5875,242.571429 L153.5875,242.571429 Z",
  id: "linkedin"
})));

function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d3b8a930.svg";
export { ForwardRef as ReactComponent };